import { firebaseAuth, base, ref, miscFirebaseToolsIp, getOrderKey, logDashboardAction } from '../config/constants';
import { log } from './Utils'
import * as moment from 'moment';
import { udpateNonMainStatusOnServer } from '../Utilities/Utils'
import Status from '../config/OrderStatusConstants.js'
import axios from 'axios'
import { algoliaPartialUpdateOrder, updateAlgoliaUpdateOnArchivedOrder } from '../../src/components/dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
//import {sendReportinApiOrderUpdate} from '../components/dashBoard/newDashboard/Reporting/ReportingUtils'

export function updateOrder(orderId, data) {
  console.log("FBUTILS: algPud2 fbx2 ++++++updateOrder");
  console.log("FBUTILS: algPud21 fbx21 orderId:" + orderId);
  console.log("FBUTILS: algPud22 fbx22 data :" + JSON.stringify(data, null, 3));

  // CHECK IF ORDER EXISTS IN MAIN FIREBASE
  console.log("fbx23 algPud22 CHECK IF ORDER EXISTS IN MAIN FIREBASE");

  ref.child('orders/' + orderId).once("value", snapshot => {
    if (snapshot.exists()) {
      console.log("algPud23 fbx24 exists!");

      base.update('orders/' + orderId, {
        // data: {uid: userUid},
        data: data,
        then(err) {
          if (!err) {
            log("fbx25 updated order no error");

          }
        }
      });
    } else {
      console.log("algPud24 fbx26 does not exists IN main db updating aloglia!");

      data.objectID = orderId;
      console.log("algPud25 fbx27 after adding objectId to data:" + JSON.stringify(data, null, 3));

      algoliaPartialUpdateOrder(data);
    }
  });
  console.log("fbx25 after checking if order exists in MAIN FIREBASE")
}

export function BackUporder(order) {
  console.log("backx1 +++++ - BackUporder");

  let newPostKey = ref.child('backups').push().key;
  console.log("dupxu12 newPostKey:" + newPostKey);
  // this.setState({ newPostKey: newPostKey });

  var d = new Date();
  order.dateNum = d.getTime(),
    order.originalDateString = order.dateString;
  order.dateString = order.originalDateString;


  ref.child('backups/' + newPostKey).set(order);
}

export function insertImageNotes(mainOrderKey, imageUrl, userEmail) {
  console.log("FBUTILS: ++++++insertImageNotes");
  console.log("FBUTILS: mainOrderKey:" + mainOrderKey);
  console.log("FBUTILS: userEmail:" + userEmail);
  console.log("imageUrl:" + imageUrl);

  let now = moment().format('MMMM Do, h:mm:ss a');



  var immediatelyAvailableReference = base.push('orders/' + mainOrderKey + '/imageNotes', {

    data: {
      imageNoteUrl: imageUrl,
      time: now,
      updatedBy: userEmail
    },

    then(err) {
      if (!err) {
        console.log("updated the update text");
        // Router.transitionTo('dashboard');
      }
    }
  });
  //available immediately, you don't have to wait for the callback to be called
  // var generatedKey = immediatelyAvailableReference.key;
}

export function getNowFormatted() {
  let now = moment().format('MMMM Do YYYY, h:mm:ss a');
  return now;
}

export function DuplicateOrderWithGetOrderNumber(order) {

  getOrderNumberAndUpdateCounter(this.createCranesReplOrderWithOrderNumber);
}


export function bringOrderFromArchives(order, email) {
  console.log("bax2 +++++ - bringOrderFromArchives");
  console.log("bax21 orderKey:" + getOrderKey(order))
  console.log("bax22 email:" + order.email)
  console.log("bax23 order:" + JSON.stringify(order, null, 3))

  // let newPostKey = ref.child('orders').push().key;
  // console.log("dupxu12 newPostKey:" + newPostKey);
  // this.setState({ newPostKey: newPostKey });

  var d = new Date();
  //order.dateNum = d.getTime(),
  order.originalDateString = order.dateString;
  //order.dateString = order.originalDateString;

  let now = moment().format('MMMM Do YYYY, h:mm:ss a');
  order.bringOrderFromArchivesOn = now;
  order.bringOrderFromArchivesBy = email;
  order.fromArchives = true;

  //CHANGE NAME
  order.name = "**FROM ARCHIVE:**" + order.name;

  //CHANGE STATUS TO NEW
  order.status = Status.new;

  //REMOVE ALGOLIA ARCHIVED
  order.algoliaArchived = false;
  order.archived = false;


  //ref.child('orders/' + order.key).set(order);
  // ref.child('orders/' + getOrderKey(order)).set(order);

  base.update('orders/' + getOrderKey(order), {
    //base.update('orders/'+orderId, {
    // data: {uid: userUid},
    data: order,
    then(err) {
      if (!err) {
        console.log("bax2411... brought back from archives");
        // Router.transitionTo('dashboard');
        //bears endpint is now {name: 'George', type: 'Grizzly'}
      }
    }
  });

 // console.log("bax24... brought back from archives")
}

export function DuplicateOrder(order) {
  console.log("dupxu1 replx3 +++++ - DuplicateOrder");

  let newPostKey = ref.child('orders').push().key;
  console.log("dupxu12 replx31 newPostKey:" + newPostKey);
  // this.setState({ newPostKey: newPostKey });

  var d = new Date();
  let now = moment().format('MMMM Do, h:mm:ss a');

  order.dateNum = d.getTime(),
    order.originalDateString = order.dateString;
  order.dateString = now;
  order.status = 'new';
  order.objectID = newPostKey;

  console.log("replx34 final order before saving:" + JSON.stringify(order, null, 3))

  //SET DATE TIME
  // if (order.cranesReplacement) {
  //   order.status = 'cranes_new';
  // } else {
  //   order.status = 'new';
  // }


  ref.child('orders/' + newPostKey).set(order);
}


export function removeUrgency(email, order) {
  console.log("mxu1 +++++ - removeUrgency");
  console.log("mxu12 email:" + email);
  console.log("mxu13 orderId:" + order.key);

  var d = new Date();
  let now = moment().format('MMMM Do, h:mm:ss a');

  let urgentObjectTemp = {
    urgent: false,
    urgentBy: email,
    urgentDateNum: d.getTime(),
    urgentTime: now,
    urgentRequiredDateSec: '',
    urgentRequiredDateString: ''
  }

  let orderUpdates = {
    urgent: false,
    lastUpdate: now,
    urgentObject: urgentObjectTemp
  }

  let eventProperties = {
    user: email,
    itemType: order.itemType
  }


  updateOrder(order.key, orderUpdates);

}

export function insertUpdateText(orderId, updateText, userEmail) {
  console.log("FBUTILS: ++++++insertUpdateText");
  console.log("FBUTILS: orderId:" + orderId);
  console.log("userEmail:" + userEmail);

  var d = new Date();
  var tt = d.getTime();


  let now = moment().format('MMMM Do, h:mm:ss a');
  //var tt = d.getTime();
  console.log("time:" + tt);

  //var immediatelyAvailableReference = base.push('orders/' + orderId + '/orderUpdates', {
  var immediatelyAvailableReference = base.post('orders/' + orderId + '/orderUpdates/' + tt, {

    data: {
      updateText: updateText,
      time: now,
      updatedBy: userEmail
    },

    then(err) {
      if (!err) {
        console.log("updated the update text");
        // Router.transitionTo('dashboard');

        udpateNonMainStatusOnServer(orderId, userEmail, Status.order_update);
        //sendUpdateToAlgolia(orderId,userEmail,updateText,now)

        updateAlgoliaUpdateOnArchivedOrder(orderId, updateText, userEmail);

        //updateOrderUpdatesArray(orderId, userEmail, updateText, now);

        // updateOrderUpdatesArray_new(orderId, userEmail, updateText, now, tt);

        let updateString = userEmail + " added update - '" + updateText + "' to " + orderId;
        console.log("ddx39 updateString:" + updateString);
        logDashboardAction(updateString, userEmail, null, "orderUpdate");
      }
    }
  });
  //available immediately, you don't have to wait for the callback to be called
  // var generatedKey = immediatelyAvailableReference.key;
}

export function updateOrderUpdatesArray_new(orderId, userEmail, updateText, now, tt) {
  console.log("upx7900 ++++++++ updateOrderUpdatesArray ");
  console.log("upx7901 orderId:" + orderId);

  let singleUpdate = {
    time: now,
    updateText: updateText,
    updatedBy: userEmail,
    number: tt
  };

  ref.child('orders/' + orderId + '/algoliaOrderUpdates/' + tt).set(singleUpdate);

  let counter = 1;

}


export function updateOrderUpdatesArray(orderId, userEmail, updateText, now) {
  console.log("upx7900 ++++++++ updateOrderUpdatesArray ");
  console.log("upx7901 orderId:" + orderId);


  let counter = 1;

  base.fetch('orders/' + orderId + '/algoliaOrderUpdates', {
    context: this,
    asArray: true,
    //state: 'shirtColors',
    then(data) {
      console.log("upx7902 num updates found by fetch:" + JSON.stringify(data, null, 3));

      if (data && Array.isArray(data)) {
        counter = data.length + 1;
        console.log("upx7903 counter now is:" + counter);
      } else {
        console.log("upx7904 no existing updates found coutner is:" + counter);
      }

      let singleUpdate = {
        time: now,
        updateText: updateText,
        updatedBy: userEmail,
        number: counter
      };


      // SET SINGLE UPDATE..
      ref.child('orders/' + orderId + '/algoliaOrderUpdates/' + counter).set(singleUpdate);
    }
  });

}




export function sendUpdateToAlgolia(orderId, adminEmail, updateText, now) {
  console.log("++++++++++: sendUpdateToAlgolia");
  console.log("orderId:" + orderId);
  console.log("adminEmail:" + adminEmail);
  console.log("updateText:" + updateText);
  console.log("now:" + now);

  let update = {};
  update.objectID = orderId;

  let orderUpdate = {};
  orderUpdate.time = now;
  orderUpdate.updateText = updateText;
  orderUpdate.updatedBy = adminEmail;

  update.orderUpdate = orderUpdate;

  axios.post(miscFirebaseToolsIp + 'postOrderUpdateToAlgolia', {
    objectID: orderId,
    orderUpdate: orderUpdate
  })
    .then((response) => {
      console.log("upex8:" + console.log(JSON.stringify(response.data, null, 3)));
    })
    .catch((error) => {
      console.log(error);
    });
}


export function getOrderNumberAndUpdateCounterNew(getOrderNumberAndSaveOrder, orderObject) {
  console.log("orderx131 cox31 ++++getOrderNumberAndUpdateCounterNew ");
  console.log("orderx132 cox32 orderObject: " + JSON.stringify(orderObject, null, 3));
  console.log("orderx133 cox33 base fetch")
  //GET THE CURRENT ORDER NUMBER
  base.fetch('orderNumberSeed', {
    context: this,
    asArray: false

  }).then(data => {
    //ADD 1 TO THE NUMBER
    console.log("orderx133 cox34 getOrderNumber old data:" + JSON.stringify(data));
    console.log("orderx134 cox35 data['orderNumberSeed']::" + data['orderNumberSeed']);

    let newOrderNumber = data['orderNumberSeed'] + 1;
    console.log("orderx135 cox36 newOrdeNumber:" + newOrderNumber);

    base.update('orderNumberSeed', {
      data: { 'orderNumberSeed': newOrderNumber },
      then(err) {
        if (!err) {
          console.log("orderx134 cox37 ordernumber seed updated to:" + newOrderNumber);

          //CALL THE FUNCTION SENT BY ORDERFORM.JS WITH THE ORDER 
          //ITS THE ONE THAT SAVES THE ORDER..
          getOrderNumberAndSaveOrder(newOrderNumber, orderObject);
        }
      }
    });


  }).catch(error => {
    //handle error
  })
}


export function getOrderNumberAndUpdateCounter(getOrderNumberAndSaveOrder) {
  console.log("replx0 +++++++ getOrderNumberAndUpdateCounter +++++")
  //GET THE CURRENT ORDER NUMBER
  base.fetch('orderNumberSeed', {
    context: this,
    asArray: false

  }).then(data => {
    //ADD 1 TO THE NUMBER
    console.log("replx01 getOrderNumber old data:" + JSON.stringify(data));
    console.log("replx02 data['orderNumberSeed']::" + data['orderNumberSeed']);

    let newOrderNumber = data['orderNumberSeed'] + 1;
    console.log("replx03 mnewOrdeNumber:" + newOrderNumber);

    base.update('orderNumberSeed', {
      data: { 'orderNumberSeed': newOrderNumber },
      then(err) {
        if (!err) {
          console.log("replx04 ordernumber seed updated to:" + newOrderNumber);

          //CALL THE FUNCTION SENT BY ORDERFORM.JS WITH THE ORDER 
          //ITS THE ONE THAT SAVES THE ORDER..
          getOrderNumberAndSaveOrder(newOrderNumber);
        }
      }
    });

  }).catch(error => {
    //handle error
  })
}


export function login(email, pw) {
  log("FBUTILS: ++++++updateuserDetails");
  log("FBUTILS: email:" + email);
  return firebaseAuth().signInWithEmailAndPassword(email, pw)
}

export function logout() {
  log("FBUTILS: ++++++logout");



  return firebaseAuth().signOut();
}

export function verifyOrderFinal(orderId, data) {
  console.log("FBUTILS: ++++++verifyOrderFinal");
  console.log("FBUTILS: orderId:" + orderId);

  base.update('orders/' + orderId, {
    //base.update('orders/'+orderId, {
    // data: {uid: userUid},
    data: data,
    then(err) {
      if (!err) {
        log("verifyOrder updated order no error");
        // Router.transitionTo('dashboard');
        //bears endpint is now {name: 'George', type: 'Grizzly'}
      }
    }
  });
}

export function verifyOrder(orderId, data) {
  console.log("FBUTILS: ++++++verifyOrder");
  console.log("FBUTILS: orderId:" + orderId);

  base.update('orders/' + orderId + '/verification', {
    //base.update('orders/'+orderId, {
    // data: {uid: userUid},
    data: data,
    then(err) {
      if (!err) {
        log("verifyOrder updated order no error");
        // Router.transitionTo('dashboard');
        //bears endpint is now {name: 'George', type: 'Grizzly'}
      }
    }
  });
}

export function updateStatus(orderId, status, user) {
  console.log("FBUTILS: ddx5 funk21 ++++++ updateStatus");
  console.log("FBUTILS ddx51 funk22 : orderId:" + orderId);
  console.log("FBUTILS ddx52 funk24 status:" + status);
  console.log("FBUTILS ddx53 funk23 email:" + user);

  let now = moment().format('MMMM Do YYYY, h:mm:ss a');
  let lastUdpatedSecs = new Date().getTime()
  let orderUpdates = {
    status: status,
    lastUpdated: now,
    lastUdpatedSecs: lastUdpatedSecs,
    updatedBy: user,
    lastUpdatedBy: user
  }

  updateOrder(orderId, orderUpdates);
}



export function updateUser(userUid, data) {
  log("FBUTILS: ++++++updateuserDetails");
  log("FBUTILS: userUid:" + userUid);
  base.update('users/' + userUid, {
    // data: {uid: userUid},
    data: data,
    then(err) {
      if (!err) {
        log("updated no error");
        // Router.transitionTo('dashboard');
        //bears endpint is now {name: 'George', type: 'Grizzly'}
      }
    }
  });
}

export function checkForUserInUserNode(userUid) {
  log("fbu2 ++++++++:checkForUserInUserNode");
  log("fbu21 userUid:" + userUid);

  return base.fetch('users', {
    context: this,
    asArray: true,
    queries: {
      orderByChild: 'uid',
      equalTo: userUid
    },
    then(data) {
      log("fbu23 got user data:" + data);
      log(JSON.stringify(data))
      //log(data);
      return data;
    }
  });

  // return data;
}

export function updateIndividualOrder(mainOrderId, indyOrderId, data) {
  console.log("FBUTILS: ++++++updateOrder");
  console.log("FBUTILS: mainOrderId:" + mainOrderId);
  console.log("FBUTILS: indyOrderId:" + indyOrderId);

  base.update('orders/' + mainOrderId + '/singleOrders/' + indyOrderId, {
    // data: {uid: userUid},
    data: data,
    then(err) {
      if (!err) {
        log("updated order no error");

        //CALL API OT UPDATE ORDER.. 
        // sendReportinApiOrderUpdate(orderId, data)

      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/Utilities/FireBaseUtils.js